export default __webpack_public_path__ + "static/media/background_product_viewer.1c892b24.png";